module.exports = __webpack_public_path__ + "img/turbo_icon.534631b4.png";